export const CATALOG_ID_UNDERGRAD_2024_TO_2025 = 38
export const CATALOG_ID_GRADUATE_2024_TO_2025 = 39
export const CATALOG_ID_UNDERGRAD_2025_TO_2026 = 40
export const CATALOG_ID_GRADUATE_2025_TO_2026 = 41